import styles from './progress.module.css';
import React, { useEffect, useState } from "react";

let interval: NodeJS.Timeout | undefined = undefined;

const ProgressBarInterval = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
          interval = setInterval(() => {
            setProgress((prev) => prev + 0.2);
          }, 10);

      }, []);
    
    useEffect(() => {
        if (progress >= 100) {
            clearInterval(interval);
        }
    }, [progress]);

    
    return (
        <div className='flex items-center'>
            <div className={`${styles.progressBar}`}>
                <div className={`${styles.progressBarPercent}`} style={{ width: `${progress}%` }} />
            </div>
        </div>
    );
};

export default ProgressBarInterval;
